import homepageHeroSwiper from '../components/homepage-hero-swiper';
import { sectorSwiper, serviceSwiper}  from '../components/sector-service-swiper'
import latestNewsSwiper from '../components/latest-news-swiper'
import testimonialsSwiper from '../components/testimonials-swiper'

export default {
	namespace: 'home',
	beforeEnter() {

	},
	afterEnter(barba) {
		console.log('View: home')
		homepageHeroSwiper(barba)
		sectorSwiper(barba)
		serviceSwiper(barba)
		latestNewsSwiper(barba)
		testimonialsSwiper(barba)
	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
